<template>
  <div class="category-container">
    <li class="nav-item">
      <div class="category">
        {{ title }}
      </div>
    </li>
    <slot name="menu" />
  </div>
</template>
<script>
export default {
  name: "category-container",
  props: {
    title: {
      type: String,
      required: false,
    }
  },
};
</script>
<style>
.category-container {
  margin-bottom: 20px;
}
.nav-item > .category {
  font-size: 1.4rem;
  font-weight: 800;
  color: black;
  margin-left: 1.5rem;
  padding: 0.5rem 0;
}
</style>
